import { render, staticRenderFns } from "./ShortTPRAlertModal.vue?vue&type=template&id=b6007b4a&"
import script from "./ShortTPRAlertModal.vue?vue&type=script&lang=js&"
export * from "./ShortTPRAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./ShortTPRAlertModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3192176617/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6007b4a')) {
      api.createRecord('b6007b4a', component.options)
    } else {
      api.reload('b6007b4a', component.options)
    }
    module.hot.accept("./ShortTPRAlertModal.vue?vue&type=template&id=b6007b4a&", function () {
      api.rerender('b6007b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShortTPRAlertModal.vue"
export default component.exports